module.exports = __webpack_public_path__ + "img/appDownload.e965fcc5.jpg";